export const ReferralBannerIcon = () => (
  <svg
    width="147"
    height="195"
    viewBox="0 0 147 203"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M93.7818 179.971L87.8451 189.097L78.7194 183.16L93.7818 179.971Z"
      fill="#9A7AFF"
    />
    <path
      opacity="0.2"
      d="M64.5635 173.648L51.2192 175.944L52.02 180.598L65.3643 178.302L64.5635 173.648Z"
      fill="#9A7AFF"
    />
    <g opacity="0.2">
      <path
        d="M143.897 179.565C140.534 180.116 135.718 187.835 129.731 194.047C121.658 202.421 115.53 183.857 115.53 183.857C115.53 183.857 117.774 180.827 119.959 184.22C121.654 186.852 122.655 193.117 127.66 189.138C132.666 185.159 134.926 178.674 143.317 178.549"
        fill="#784EFF"
      />
      <path
        d="M119.96 184.22C119.96 184.22 112.987 181.35 105.371 194.6C97.7555 207.851 83.8087 195.737 83.8087 195.737L87.6004 193.16C87.6004 193.16 98.3592 199.975 102.536 192.114C108.526 180.838 114.186 176.013 119.96 184.22Z"
        fill="#BBA7FF"
      />
      <path
        d="M134.51 182.127C134.51 182.127 147.597 181.189 150.746 191.589L155.652 192.091C145.657 169.262 134.51 182.127 134.51 182.127Z"
        fill="#BBA7FF"
      />
    </g>
    <g opacity="0.2">
      <path
        d="M153.287 23.7203C150.203 22.2707 141.863 25.908 133.411 27.6395C122.016 29.9732 127.473 11.2017 127.473 11.2017C127.473 11.2017 131.037 9.97379 130.918 14.0077C130.826 17.1368 128.105 22.868 134.483 22.4212C140.862 21.9745 146.396 17.9079 153.384 22.5544"
        fill="#784EFF"
      />
      <path
        d="M130.919 14.0082C130.919 14.0082 126.796 7.69484 113.017 14.3071C99.2381 20.92 94.598 3.03893 94.598 3.03893L99.1828 3.06044C99.1828 3.06044 104.194 14.7685 112.088 10.6523C123.408 4.74777 130.805 3.97394 130.919 14.0082Z"
        fill="#BBA7FF"
      />
      <path
        d="M144.099 20.5195C144.099 20.5195 155.418 27.1538 152.127 37.5095L155.888 40.7004C160.57 16.2229 144.099 20.5195 144.099 20.5195Z"
        fill="#BBA7FF"
      />
    </g>
    <path
      opacity="0.2"
      d="M148.389 60.1929C148.272 56.0618 144.301 52.4474 140.176 52.7177C138.147 52.8511 136.179 53.7826 134.157 53.5616C131.226 53.2398 129.146 50.6684 127.281 48.3827C125.325 45.9865 123.17 43.634 120.38 42.2939C117.592 40.9551 114.026 40.8288 111.579 42.7197C112.627 44.0276 113.401 45.1568 114.45 46.4647C112.742 47.7204 111.013 49.0924 109.305 50.3481C112.858 50.0158 116.571 51.0781 119.423 53.2216C122.877 55.8188 125.415 60.076 129.66 60.8921C132.664 61.4704 135.919 60.1243 138.761 61.2546C140.985 62.1389 142.39 64.3349 143.403 66.5043C143.664 64.6599 143.902 62.8074 144.162 60.9616C145.812 60.7945 146.745 59.9919 148.389 60.1929Z"
      fill="#784EFF"
    />
    <path
      opacity="0.2"
      d="M87.6836 61.14L75.5645 59.0071L79.8891 51.1094L88.8079 59.0868L87.6836 61.14Z"
      fill="#9A7AFF"
    />
    <path
      opacity="0.2"
      d="M92.2641 34.7051C94.8478 34.7051 96.9423 32.6106 96.9423 30.0269C96.9423 27.4432 94.8478 25.3488 92.2641 25.3488C89.6804 25.3488 87.5859 27.4432 87.5859 30.0269C87.5859 32.6106 89.6804 34.7051 92.2641 34.7051Z"
      fill="#9A7AFF"
    />
    <path
      opacity="0.2"
      d="M42.9336 25.9358L44.9605 32.174H51.5211L46.2139 36.03L48.2408 42.2683L42.9336 38.4133L37.6264 42.2683L39.6543 36.03L34.3472 32.174H40.9067L42.9336 25.9358Z"
      fill="#BBA7FF"
    />
    <g opacity="0.7">
      <path
        d="M141.076 171.178L8.37473 160.459C3.36025 160.054 -0.376494 155.661 0.0291623 150.646L6.28341 73.2245C6.68831 68.21 11.0821 64.4732 16.0959 64.8789L148.797 75.5984C154.239 76.0382 158.294 80.8058 157.854 86.248L151.726 162.121C151.286 167.562 146.518 171.618 141.076 171.178Z"
        fill="#BBA7FF"
      />
      <g opacity="0.2">
        <path
          d="M2.42873 120.941L157.999 84.4669L157.045 96.2727L1.12744 137.053L2.42873 120.941Z"
          fill="black"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M89.7476 70.8499L103.184 108.869L116.305 169.199L130.368 170.335L107.751 99.8619L102.346 71.8678L89.7476 70.8499Z"
          fill="black"
        />
      </g>
      <path
        d="M103.386 100.377C102.967 105.222 106.213 104.662 101.1 108.169C96.5227 111.29 89.7908 117.744 84.2582 118.63C76.9781 119.796 77.2223 111.992 76.6271 106.413C75.9743 102.336 75.3454 102.138 79.5267 100.274C82.0075 98.98 85.5015 98.4207 88.4137 97.9542C93.7025 97.4067 96.0557 97.7078 103.34 100.085L103.386 100.377Z"
        fill="#696088"
      />
      <path
        d="M103.378 100.18C101.746 98.4329 98.5713 97.7652 96.3254 97.2167C92.9981 96.4043 89.4217 96.3566 86.0351 96.646C82.9263 96.9123 74.6124 97.7958 76.0673 102.806C77.0583 106.219 82.4187 102.917 84.0271 101.868C87.7274 99.4577 93.2132 98.4289 97.5488 98.8143C98.6943 98.9159 99.9036 99.1981 101.011 99.498C101.502 99.6311 103.193 100.378 103.285 100.108"
        fill="#514B67"
      />
      <path
        d="M100.005 103.111C101.503 103.402 103.065 104.171 104.564 104.462C106.386 109.091 105.183 118.498 104.613 123.441C103.669 131.111 100.666 139.779 95.8497 145.764C95.7345 141.154 96.8144 136.389 95.2621 131.967C90.9852 132.77 86.7207 135.519 82.8088 137.247C84.8657 130.65 89.9205 124.633 92.2172 118.004C94.3382 111.885 94.9712 107.421 99.4958 102.934"
        fill="#696088"
      />
      <path
        d="M112.849 104.396C113.232 105.639 114.706 106.558 115.6 107.426C118.25 110.003 121.032 112.431 123.657 115.03C127.787 119.12 130.942 124.34 132.941 129.761C133.728 131.899 134.367 134.095 134.717 136.349C134.841 137.147 135.033 138.73 134.145 137.387C131.859 133.93 128.444 131.339 125.258 128.735C124.622 128.217 123.932 127.552 123.165 127.259C123.556 129.518 122.503 131.901 121.715 134.03C121.06 135.792 120.102 137.413 119.192 139.06C118.778 139.808 118.115 141.695 117.287 142.027C117.869 140.65 117.769 139.04 117.706 137.577C117.606 135.266 117.366 132.9 116.654 130.69C115.436 126.905 112.973 123.644 111.398 120.011C109.654 115.994 108.442 111.824 108.509 107.407C108.528 106.062 108.349 104.519 108.773 103.217C109.088 102.256 109.321 102.599 109.979 102.996C110.488 103.303 111.072 103.455 111.6 103.682C111.96 103.837 112.462 104.266 112.843 104.26"
        fill="#696088"
      />
      <path
        d="M106.052 104.858C109.587 108.198 106.791 109.938 112.941 109.157C118.436 108.443 127.755 108.786 132.476 105.768C138.689 101.797 133.316 96.1311 130.049 91.5693C127.825 88.0906 128.163 87.5237 123.801 88.9128C121.088 89.5973 118.107 91.5034 115.622 93.092C111.308 96.1995 109.751 97.9903 105.893 104.61L106.052 104.858Z"
        fill="#696088"
      />
      <path
        d="M105.926 104.706C105.984 102.316 107.91 99.7059 109.222 97.8031C111.167 94.9831 113.806 92.5686 116.527 90.5332C119.026 88.6638 125.822 83.7945 128.068 88.5038C129.597 91.7107 123.398 92.81 121.5 93.0968C117.134 93.7579 112.352 96.6385 109.371 99.8095C108.583 100.648 107.868 101.662 107.24 102.622C106.962 103.049 106.196 104.731 105.948 104.59"
        fill="#514B67"
      />
      <path
        d="M110.281 97.7004C108.885 99.2977 109.079 102.352 109.118 104.33C109.158 106.433 110.247 108.329 110.683 110.344C110.753 110.666 110.857 110.946 110.814 111.255C110.725 111.892 110.959 111.561 110.344 111.785C109.631 112.045 108.699 112.038 107.934 112.217C106.359 112.585 104.176 113.086 102.84 112.077C99.3564 109.451 98.5519 105.15 99.6472 101.063C100.135 99.2423 100.854 98.1542 102.788 97.9663C104.635 97.7862 106.554 97.7638 108.389 97.7086C109.064 97.6881 109.705 97.5628 110.321 97.8629"
        fill="#514B67"
      />
    </g>
  </svg>
);
